import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { loadRecommendations, loadRecommendationsProducts } from './actions';
import {
  makeSelectArticlesError, makeSelectArticlesLoading, makeSelectProductsError, makeSelectProductsLoading,
  makeSelectProductsRecommendations, makeSelectArticlesRecommendations, makeSelectArticlesType, makeSelectProductsType,
} from './selectors';
import immutableToJS from '../../utils/immutable_to_js';
import RecommendationsList from '../../components/RecommendationsList';
import Loader from './loader';
import { injectIntl } from 'react-intl';
import messages from './messages';

export class MostVisitedRecommendationsWidget extends React.PureComponent {
  componentDidMount() {
    this.props.loadRecommendedContent();
  }

  recommendationsToListItem() {
    return this.props.recommendations.map((item, index) => (
      {
        id: index,
        title: item.title,
        description: item.type,
        image: item.image,
        url: item.url,
      }
    ));
  }

  render() {
    if (this.props.loading) {
      return (
        <Loader />
      );
    }
    return (
      <RecommendationsList
        listTitle={this.props.intl.formatMessage(messages[`title${this.props.type}`])}
        items={this.recommendationsToListItem()}
      />
    );
  }
}

MostVisitedRecommendationsWidget.propTypes = {
  type: PropTypes.string.isRequired,
  loadRecommendedContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  recommendations: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
};

const mapArticlesDispatchToProps = dispatch => ({
  loadRecommendedContent: () => dispatch(loadRecommendations()),
});

const mapArticlesStateToProps = createStructuredSelector({
  recommendations: makeSelectArticlesRecommendations(),
  loading: makeSelectArticlesLoading(),
  error: makeSelectArticlesError(),
  type: makeSelectArticlesType(),
});

const mapProductsDispatchToProps = dispatch => ({
  loadRecommendedContent: () => dispatch(loadRecommendationsProducts()),
});

const mapProductsStateToProps = createStructuredSelector({
  recommendations: makeSelectProductsRecommendations(),
  loading: makeSelectProductsLoading(),
  error: makeSelectProductsError(),
  type: makeSelectProductsType(),
});

export const MostVisitedArticlesWidget = connect(mapArticlesStateToProps, mapArticlesDispatchToProps)(injectIntl(immutableToJS(MostVisitedRecommendationsWidget)));
export const MostVisitedProductsWidget = connect(mapProductsStateToProps, mapProductsDispatchToProps)(injectIntl(immutableToJS(MostVisitedRecommendationsWidget)));
